import { Container, Texture, Sprite, Rectangle, Circle, Assets } from 'pixi.js';
import { useBattleStore } from '@/store/useBattleStore';
import { BattleStatus } from '@/core/types/battle.types';
import { pauseToggle } from '@/core/utils/battle.utils';
import skills from '@assets/skills/skills.png'

const SIZE = 48;
const ATLAS_ICON_SIZE = 96;
const ATLAS_URL = skills;

export class SettingsButton extends Container {
    private iconContainer: Container;
    public onLayoutChange?: () => void;

    constructor() {
        super();
        this.iconContainer = new Container();
        this.build();
    }

    private build(): void {
        const atlasTexture: Texture | null = Assets.get(ATLAS_URL) ?? null;

        if (atlasTexture) {
            const padding = 1;
            const frame = new Rectangle(
                1 * ATLAS_ICON_SIZE + padding,
                0 * ATLAS_ICON_SIZE + padding,
                ATLAS_ICON_SIZE - padding * 2,
                ATLAS_ICON_SIZE - padding * 2
            );

            const texture = new Texture({
                source: atlasTexture.source,
                frame,
            });

            const sprite = new Sprite(texture);
            sprite.width = SIZE;
            sprite.height = SIZE;
            this.iconContainer.addChild(sprite);
        }

        this.iconContainer.pivot.set(SIZE / 2, SIZE / 2);
        this.iconContainer.position.set(SIZE / 2, SIZE / 2);
        this.addChild(this.iconContainer);

        this.hitArea = new Circle(SIZE / 2, SIZE / 2, SIZE / 2);
        this.eventMode = 'static';
        this.cursor = 'pointer';

        this.on('pointerdown', () => {
            pauseToggle(useBattleStore.getState());
        });
        this.on('pointerover', () => { this.iconContainer.scale.set(1.1); });
        this.on('pointerout', () => { this.iconContainer.scale.set(1.0); });

        this.onLayoutChange?.();
    }
}